<template>
    <v-card class="product-card rounded-xl white overflow-hidden" elevation="0"
        :to="{ name: 'product_detail', params: { id: product.id } }" hover>
        <div class="pa-2">
            <v-img :src="getProductImage(product)" aspect-ratio="1" contain class="white rounded-xl">
                <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="#198C19" />
                    </v-row>
                </template>
            </v-img>
        </div>
        <div class="px-3 pb-3 pt-0">
            <div class="text-body-1 font-weight-bold mb-1"
                style="line-height: 1.4; height: 48px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical;">
                {{ product.productName || product.name || product.title }}
            </div>

            <div class="text-caption grey--text text--darken-1 mb-2">
                {{ getProductMetaInfo(product) }}
            </div>

            <!-- Rating row — always reserve space -->
            <div class="d-flex align-center mb-1" style="height:18px;">
                <template v-if="product._reviewAvg">
                    <v-icon x-small color="#F59E0B">mdi-star</v-icon>
                    <span class="text-caption ml-1 font-weight-bold" style="color:#B45309;">{{ Number(product._reviewAvg).toFixed(1) }}</span>
                    <span class="text-caption grey--text ml-1">({{ product._reviewCount || 0 }})</span>
                </template>
            </div>

            <!-- Price -->
            <div class="font-weight-bold text-h6">
                {{ formatPrice(product.price) }} บาท
            </div>
        </div>
    </v-card>
</template>

<script>
import { getAddress } from "@/utils/address";
import { getProductImage, getImageUrl } from "@/utils/image";

export default {
    name: "ProductCard",
    props: {
        product: {
            type: Object,
            required: true
        },
    },
    methods: {
        formatPrice(price) {
            if (!price && price !== 0) return "0.00";
            return parseFloat(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        getProductImage,
        getImageUrl,
        formatWeight(weight) {
            if (!weight || weight <= 0) return "0 g";
            if (weight >= 1000) {
                const kg = weight / 1000;
                return `${kg.toFixed(kg % 1 === 0 ? 0 : 1)} kg`;
            }
            return `${Math.round(weight)} g`;
        },
        getShopLocation(product) {
            const seller = product.seller || product.shop;
            if (!seller) return "";
            const addr = getAddress(seller);
            // Example: "จ.กรุงเทพมหานคร"
            return addr.province?.nameTh ? `จ.${addr.province.nameTh}` : "";
        },
        getProductMetaInfo(product) {
            const parts = [];
            // if (product && product.weight >= 0) {
            //     parts.push(this.formatWeight(product.weight));
            // }
            const location = this.getShopLocation(product);
            if (location) {
                parts.push(location);
            }
            return parts.join(" • ");
        },

    }
};
</script>

<style scoped>
.product-card {
    transition: all 0.3s ease;
    cursor: pointer;
    text-decoration: none;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.product-card:hover {
    transform: translateY(-4px);
    /* box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important; */
}
</style>
